export default "__VITE_ASSET__KgpRxJIl__"